import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

export interface ConfigValueRaw {
    configKey: { code: string };
    value: string;
}

@Injectable({
    providedIn: 'root',
})
export class ConfigValueCacheService {
    private static readonly ENDPOINT = 'config-value/v1/list';
    private cache$: Observable<ConfigValueRaw[]>;

    constructor(private http: HttpClient) {}

    public getAll(): Observable<ConfigValueRaw[]> {
        if (!this.cache$) {
            const url = `${environment.api.url}${environment.api.prefix}/${ConfigValueCacheService.ENDPOINT}`;
            this.cache$ = this.http.get<ConfigValueRaw[]>(url).pipe(shareReplay(1));
        }
        return this.cache$;
    }

    public getValue(code: string): Observable<string | undefined> {
        return this.getAll().pipe(map((configs) => configs.find((c) => c.configKey?.code === code)?.value));
    }
}
